module.exports = __webpack_public_path__ + "static/christmas-movies-d50c7f32724e68500ed8c56c2b8e4a9b.gif";